export default "__VITE_ASSET__Mza5P5Rt__"